S.nav = {
    config: {},
    elements: {
        $burger: null,
        $navMain: null,

        $navLink: null,
        $search: null,
    },

    /** @var menu list points */
    $menuPoints: null,

    /** @var menu $menuPointsLink */
    $menuPointsLink: null,

    /** @var menu burger menu */
    $burger: null,

    /** @var search button */
    $search: null,

    /** @var $searchInput */
    $searchInput: null,

    /** @var $searchSubmit */
    $searchSubmit: null,

    /** @var $nav */
    $nav: null,

    $closeSVGHtml:
        '<button class="is-search-close">' +
        '<svg class="m-search-bar-close" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 19 19">\n' +
        '  <polygon fill="#d71106" fill-rule="evenodd" points="19 1.9 17.1 0 9.5 7.6 1.9 0 0 1.9 7.6 9.5 0 17.1 1.9 19 9.5 11.4 17.1 19 19 17.1 11.4 9.5"/>\n' +
        '</svg>' +
        '</button>',

    scrollY: null,
    scrollUp: null,
    scrollDown: null,
    lastScroll: null,
    locked: false,
    stickyPosition: 100,

    init()
    {
        // if IE - set body class
        if (S.ie())
        {
            $('body').addClass('is-IE');
        }

        // save menu var
        this.$menuPoints = this.$module.find('.m-nav').find('> li');
        this.$menuPointsLink = this.$menuPoints.find('> a');
        this.$nav = this.$module.closest('nav');

        // save burger and search items
        this.$burger = this.$module.find('.m-burger');
        this.$search = this.$module.find('.m-search');
        this.$searchInput = this.$module.find('input[type="search"]');
        this.$searchSubmit = this.$module.find('button[type="submit"]');

        // check for submenu
        this.$menuPoints.each((_, element) =>
        {
            const $element = $(element);

            if ($element.find('.m-sub-menu').length)
            {
                $element.addClass('has-sub');
            }
        });
    },

    /**
     * init when all modules are initialized
     */
    start()
    {
        // init nav events
        this.initEvents();

        // init resize
        this.resize();

        // init sticky
        this.initStickyLogic();
    },

    /**
     * init needed events
     */
    initEvents()
    {
        /**
         * only for burger menuy
         */
        this.$burger.on('click', () =>
        {
            this.naviToggle();
            this.$search.removeClass('is-active');

            S.delayed('burger-switch', 200, () =>
            {
                this.closeSubmenus();
            });

            // remove locked state
            this.locked = true;
        });

        /**
         * main navi points mobile/desktop
         *
         * - hanlde submenu open/close
         */
        this.$menuPointsLink.on('click', (e) =>
        {
            if (!S.mq('desktop').matches)
            {
                const $clickedTarget = $(e.currentTarget);

                if ($clickedTarget.next('.m-sub-menu').length)
                {
                    e.preventDefault();
                    const $clickedListMenu = $clickedTarget.closest('li');

                    if ($clickedListMenu.hasClass('is-active'))
                    {
                        // toggle acitve class
                        $clickedListMenu.removeClass('is-active');
                    }
                    else
                    {
                        this.closeSubmenus();
                        $clickedListMenu.addClass('is-active');
                    }

                    return;
                }
                else {
                    // if the user clicks on a link that has no children/submenu - it will open it and to visualize the click, remove no-scroll style
                    S.removeNoScroll();
                }

                // toggle menu class
                this.$module.toggleClass('is-active');
            }
            else
            {
                const $clickedTarget = $(e.currentTarget);

                if ($clickedTarget.next('.m-sub-menu').length)
                {
                    e.preventDefault();
                }
            }
        });

        // append svg html with container
        this.$search.find('form').append(this.$closeSVGHtml);

        /**
         * open and close search layer
         */
        this.$search.find('.m-icon').on('click', () =>
        {
            this.$search.toggleClass('is-active');

            // toggle menu class
            if (this.$module.hasClass('is-active'))
            {
                // remove locked state
                this.closeNavigation();
                this.closeSubmenus();
            }
        });

        /**
         * prevent submitting when value is empty
         */
        this.$searchSubmit.each((_, element) => {
            const $element = $(element),
                $searchInput = $element.closest('form').find('input[type="search"]');

            $element.on('click', (e) =>
            {
                if (!$searchInput.val().length)
                {
                    e.preventDefault();

                    // remove locked state
                    this.locked = false;
                }
            });

        })

        this.$searchInput.on('focus', () =>
        {
            this.locked = true;
        });

        this.$searchInput.on('blur', () =>
        {
            this.locked = false;
        });

        /**
         * add close logic for search layer
         */
        this.$search.find('.is-search-close').on('click', (e) =>
        {
            e.preventDefault();

            // remove locked state
            this.locked = false;

            this.$search.toggleClass('is-active');
        });

    },

    /**
     * navi toggle
     */
    naviToggle()
    {
        if (this.$module.hasClass('is-active'))
        {
            this.$module.removeClass('is-active');

            S.removeNoScroll();

            return;
        }

        S.setNoScroll(false, true);

        // add class
        this.$module.addClass('is-active');
    },

    /**
     * just close navigation
     */
    closeNavigation()
    {
        // close container
        this.$module.removeClass('is-active');

        // remove body class if there is one
        S.removeNoScroll();
    },

    /**
     * remove active class and close all submenus
     */
    closeSubmenus()
    {
        this.$menuPoints.removeClass('is-active');
    },

    /**
     * handle sticky logic
     */
    initStickyLogic()
    {
        window.addEventListener('scroll', () =>
        {
            // add delay
            S.delayed('sticky-header', 5, () =>
            {
                this.scrollY = Math.round(window.pageYOffset);

                if (this.scrollY > this.lastScroll && this.scrollDown)
                {
                    // up
                    this.scrollUp = true;
                    this.scrollDown = false;
                }
                else if (this.scrollY < this.lastScroll && !this.scrollDown)
                {
                    // down
                    this.scrollUp = false;
                    this.scrollDown = true;
                }

                this.lastScroll = this.scrollY;

                if (this.scrollY > this.stickyPosition)
                {
                    this.$nav.addClass('is-sticky');
                }
                else
                {
                    this.$nav.removeClass('is-sticky');
                }

                if (this.scrollUp && this.scrollY > this.stickyPosition && !this.locked)
                {
                    this.$nav.addClass('m-scroll-up');
                }
                else
                {
                    if (!this.locked) {
                        this.$nav.removeClass('m-scroll-up');
                    }
                }

                if (this.scrollDown || this.locked)
                {
                    this.$nav.addClass('m-scroll-down');
                }
                else
                {
                    this.$nav.removeClass('m-scroll-down');
                }
            });

            // disable passive listener (equal to preventDefault for scroll)
        }, {passive: true});
    },

    /**
     * lock navi, if menu is open
     * @param {Boolean} naviState
     */
    lockNavi(naviState)
    {
        this.locked = naviState;
    },

    /**
     * only close the magnificPopup on mobile
     */
    resize()
    {
        window.addEventListener('resize', () =>
        {
            S.delayed(`nav-close`, 300, () =>
            {
                if (!S.mq('desktop').matches)
                {
                    this.closeNavigation();
                    this.closeSubmenus();
                }

                S.removeNoScroll();
            });
        }, { passive: true});
    },
};
